// extracted by mini-css-extract-plugin
export default {"contentContainer":"ErrorContent_contentContainer__1AXF4"};